<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="calendar-block">
    <div class="has-side-bars">
      <div class="calendar-block-header">
        <h2 class="calendar-block-title">{{ $t('calendar_title') }}</h2>
        <h3 class="calendar-block-description">{{ $t('calendar_desc') }}</h3>
      </div>
      <template v-if="calendarAttributeMonth">
        <div v-if="calendarAttributeMonth.code === 500" class="cms-error">{{ $t('not_cms') }}</div>
        <div v-else class="cols-calendar">
          <div class="calendar-wrap">
            <v-calendar
              :attributes="calendarAttributeMonth"
              :masks="masks"
              :locale="$store.state.i18n.lang"
              @update:from-page="updateRange"
            >
              <!--v-on="dayEvents"-->
              <div
                v-if="attributes"
                slot="day-content"
                slot-scope="{ day, attributes }"
                class="day-content"
                :data-date="day.date"
                :class="
                  (attributes.length ? ' have-dot' : '') +
                    (new Date(day.date) < today ? ' past' : '') +
                    (new Date(day.date).toDateString() === today.toDateString() ? ' today' : '') +
                    (selectedDay && new Date(day.date).toDateString() === selectedDay.toDateString() ? ' selected' : '')"
                @click="onDayClick"
              >
                <div
                  class="day-label"
                >
                  {{ day.day }}
                </div>
                <div class="dots-calendar-wrap">
                  <div
                    v-if="attributes.length"
                    class="dot-calendar-wrap"
                  >
                    <div class="dot-calendar-dot" />
                  </div>
                </div>
              </div>
            </v-calendar>
          </div>
          <div class="cal-options-wrap">
            <div class="cal-info-wrap">
              <div v-if="selectedDay && eventsFromSelectedDate.length !== 0" class="calendar-cards">
                <CalendarCard v-for="op in eventsFromSelectedDate" :key="op.id" :card="op" />
              </div>
              <div v-else-if="!selectedDay" class="feedback-label">
                {{ $t('no_date_selected') }}
              </div>
              <div v-else class="feedback-label">
                {{ $t('no_date_events') }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="loader-wrap">
        <Loader :text="$t('loading')" />
      </div>
    </div>
  </div>
</template>

<script>
import CalendarCard from './CalendarCard.vue'
import Loader from '../Loader.vue'
import { getCMSCalendar } from '@/services/graphql'
import dayjs from 'dayjs'
export default {
  components: { CalendarCard, Loader },
  props: {},
  data() {
    const now = new Date()
    const month = now.getMonth()
    const year = now.getFullYear()
    const day = now.getDate()
    return {
      selectedDay: new Date(year, month, day),
      masks: {
        weekdays: 'WWW',
      },
      today: new Date(year, month, day),
      dateFrom: '',
    }
  },
  computed: {
    eventsFromSelectedDate() {
      if (!this.calendarAttributes || !this.selectedDay) return []
      else {
        return this.calendarAttributes
      }
    },
  },
  asyncComputed: {
    calendarAttributes() {
      // return this.fakeAttributes
      return getCMSCalendar(
        this.$store.state.i18n.lang,
        dayjs(this.selectedDay).format('YYYY-MM-DD')
      ).then(resp => {
        return resp.sort((a, b) => {
          return a.dates - b.dates
        })
      })
    },
    calendarAttributeMonth() {
      // return this.fakeAttributes
      return getCMSCalendar(this.$store.state.i18n.lang, this.dateFrom)
    },
  },
  watch: {},
  methods: {
    updateRange(e) {
      this.dateFrom = dayjs(new Date(e.year, e.month - 1, 1)).format('YYYY-MM-DD')
    },
    // haveDotInfo(day) {
    //   if (
    //     this.calendarAttributes?.find(el => dayjs(el.dates).format('x') === dayjs(day).format('x'))
    //   )
    //     return true
    //   else return false
    // },
    // dotsForDays(attr) {
    //   let dotsArray = []
    //   attr?.forEach(el => {
    //     if (
    //       dotsArray.find(
    //         ele => dayjs(ele.dates).format('DDMMYYYY') === dayjs(el.dates).format('DDMMYYYY')
    //       ) === undefined
    //     ) {
    //       dotsArray.push(el)
    //     }
    //   })
    //   return dotsArray
    // },
    onDayClick(e) {
      // let dayC = [...day.currentTarget.classList]
      let Sday = new Date(e.currentTarget.getAttribute('data-date'))
      if (this.selectedDay && this.selectedDay.toDateString() === Sday.toDateString()) {
        //this.selectedDay = null
      } else {
        this.selectedDay = Sday
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.calendar-block
  padding-top: vw(90px)
  padding-bottom: vw(90px)
  background: linear-gradient(111.2deg, rgba(#54AEEF, 0.15) 13.97%, rgba(#FFFFFF, 0.15) 120.58%)

  .mobile &
    padding-top: vw(50px)
    padding-bottom: vw(50px)

  .calendar-block-header
    margin-bottom: vw(40px)

  .calendar-block-title
    m-font-size(35, 45)
    margin-block-start: 0
    margin-block-end: vw(10px)
    font-weight: 600
    color: $base-font-color

  .calendar-block-description
    m-font-size(18, 26)
    color: $grey
    font-weight: 400
    margin-block-start: 0
    margin-block-end: 0

    .mobile &
      text-align: center

  .cms-error
    m-font-size(20, 26)
    display: flex
    justify-content: center
    margin-top: vw(20px)
    padding-bottom: vw(10px)
    width: 100%
    color: black
    font-weight: 400

  .cols-calendar
    display: flex
    margin-top: vw(40px)
    gap: 20px

    .mobile &
      flex-direction: column

    .calendar-wrap
      flex: 0 0 vw(350px)
      width: vw(350px)
      height: vw(350px)

      >>> .vc-container
        width: 100%
        height: 100%
        border: none

      >>> .vc-header,
      >>> .vc-arrows-container
        padding: vw(20px) vw(15px)

      >>> .vc-title
        m-font-size(24, 28)
        color: #000
        font-weight: 400

      >>> .vc-weeks
        padding: 0 vw(15px) vw(30px)

      >>> .vc-day
        margin-bottom: vw(10px)
        min-height: vw(30px)
        width: vw(30px)
        height: vw(30px)

      .dot-calendar-wrap
        display: flex

      .day-content
        position: relative
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        padding: vw(5px)
        height: 100%
        border-radius: 9px
        color: #000
        cursor: pointer

        &:hover
          background-color: $bcn-table-highlight

        &.today
          background-color: #d2e1ec

        &.past
          background-color: $bcn-very-light-grey
          color: $grey-grey

        &.have-dot
          color: #000

        &.selected
          background-color: $corporate_color
          color: #fff

          &.have-dot
            height: 130%

            .day-label
              margin-top: -30%

            .dot-calendar-dot
              bottom: 6px

          .dot-calendar-dot
            background-color: #fff

        .day-label
          m-font-size(12, 12)

        .dots-calendar-wrap
          display: flex

        .dot-calendar-dot
          position: absolute
          bottom: -3px
          left: 50%
          width: 6px
          height: 6px
          border-radius: 50%
          background-color: $corporate_color
          transform: translateX(-50%)

    .cal-options-wrap
      flex: 1 1 0%
      height: vw(350px)
      overflow: auto
      border-radius: 8px
      background-color: #fff
      
      .cal-info-wrap
        flex: 1 1 0%
        padding: vw(30px)

        .mobile &
          width: 100%
          height: 300px

        .calendar-cards
          display: flex
          flex-direction: column
          overflow-y: auto
          height: 100%
          gap: vw(20px)

        .calendar-card
          &:not(:last-child)
            border-bottom: 1px solid $light-grey

        .feedback-label
          m-font-size(18, 22)
          font-weight: 400

.loader-wrap
  position: relative
  width: 100%
  height: 110px
</style>